<template>
  <div class= "neighborViewList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="gardenId">
            <el-option
              v-for="(item,index) in gardens"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="key"
            :placeholder="$t('lang.lab_keyword')"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_add')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? 552 : 132"
      >
        <el-table-column type="selection" width="55" v-if="this.neighborViewlistcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column 
          prop="gardenName" 
          :label="$t('lang.lab_OwnerVillageall')">
          <template slot-scope="scope">
             <div>{{ scope.row.gardenName | valueIsNull }}</div>
          </template>
        </el-table-column>
        <el-table-column 
          prop="gardenName" 
          :label="$t('lang.lab_OwnerSort')">
          <template slot-scope="scope">
             <div>{{ scope.row.orderBy | valueIsNull }}</div>
          </template>
        </el-table-column>
        <el-table-column 
          prop="gardenName" 
          :label="$t('lang.lab_moduleName')">
          <template slot-scope="scope">
             <div>{{ scope.row.appModule | valueIsNull }}</div>
          </template>
        </el-table-column>
        <el-table-column 
          fixed="right"
          prop="operation" 
          :label="$t('lang.lab_operation')" 
          :width="require('@/config/enum').opr_width3">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>
<script>
/**
 *@ClassName:neighborViewList
 *@Description:APP布局
 *@author:李忠亮
 *@Copyright:格众科技
 *@date:2020-08-20
 */
export default {
  name:'/manage/main.appplotList',
  data() {
    return {
      multipleSelection: [], // 多选框
      tableData: [], // 查询list
      gardenId: this.$store.getters.gardenId, // 绑定小区值
      key: '', // 关键字
      gardens: [], // 小区范围
      type: '', // 1:楼 2：单元 3：房间
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      pageCount: 0, // 总页数
      neighborViewlistcheckbox: require('@/config/enum').neighborViewlistcheckbox // 是否隐藏复选框
    }
  },
  created() {
    setTimeout(() => {
         window.localStorage.setItem('appplotForm', '')
         window.localStorage.setItem('appplotSaveData', '')
      }, 200)
    this.selectGarden()
    this.getData()
  },
  methods: {
    // 小区下拉
    selectGarden() {
      let myGardens = [...this.$store.getters.userGardenList]
      let index = myGardens.findIndex(item => item.id === 0)
      if (index != -1) {
        myGardens.splice(index, 1)
      }
      this.gardens = myGardens
    },
    // app布局-获取列表数据
    getData() {
      let loading = this.$loading()
      this.$get(`/appplot?gardenid=${this.gardenId}&keyword=${this.key}&pageSize=${this.pageSize}&pageNo=${this.pageNo}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 新增
    add() {
      window.localStorage.setItem('appplotForm', '')
      window.localStorage.setItem('appplotSaveData', '')
      this.$router.push({ name: 'appplotAdd', query: { flag: false } })
    },
    // 详情
    details(id) {
      this.$router.push({ name: 'votingUsersList', query: { id: id } })
    },
    // 编辑
    edit(id) {
      window.localStorage.setItem('appplotForm', '')
      window.localStorage.setItem('appplotSaveData', '')
      this.$router.push({ name: 'appplotEdit', 
      query: { 
        id: id, 
        flag: true } })
    },
    // 删除
    deleteOne(id) {
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
          this.$delete(`/appplot/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 查询
    commit() {
      this.pageNo = 1
      this.getData()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getData()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getData()
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
  }
}
</script>

<style lang="scss">
.el-tooltip__popper.is-light {
  max-width: 300px;
}
</style>